import request from '@/utils/http';
import { SRM } from '../constant/constant.js';

// 查询
export const queryLessSystem = data => {
    return request({
        url: `${SRM}/supplierLessSystem/query`,
        method: 'post',
        data
    });
};

// 新增
export const createLessSystem = data => {
    return request({
        url: `${SRM}/supplierLessSystem/create`,
        method: 'post',
        data
    });
};

// 编辑
export const saveLessSystem = data => {
    return request({
        url: `${SRM}/supplierLessSystem/save`,
        method: 'post',
        data
    });
};

// 删除
export const deleteLessSystem = data => {
    return request({
        url: `${SRM}/supplierLessSystem/delete`,
        method: 'post',
        data
    });
};